import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import Login from '../pages/Login';

const loginSearchSchema = z.object({
  email: z.string().optional(),
  mode: z.enum(['sso', 'password']).optional(),
  redirect: z.string().optional(),
});

export const Route = createFileRoute('/login')({
  component: Login,
  validateSearch: loginSearchSchema,
});
